module.exports = __webpack_public_path__ + "img/home.da20c65c.png";